define('app/views/travel_search_plane_view',['app/setup',
  'jquery.sumoselect',
  'app/lib/pwt/persian-date',
  'app/lib/pwt/persian-datepicker',
  'app/collections/travel_plane_collection'],
  function(takhfifan, sumoSelect, persianDate, pdp) {
  takhfifan.travelSearchPlaneView = Backbone.View.extend({
    events: {
      'submit form': 'searchFormSubmit',
      'change select': 'setModelData',
      'click .tkh-travel-plane-search__dir': 'changeDirection'
    },

    cardTemplate: ( $('#travel-plane-card').length > 0 ) ?
      _.template( $('#travel-plane-card').html() ) : '',

    filtersTemplate: ( $('#travel-plane-filters').length > 0 ) ?
      _.template( $('#travel-plane-filters').html() ) : '',


    initialize: function () {
      window.persianDate = persianDate;
      Backbone.Validation.bind(this);

      this.generateSelectBoxes();
      this.generateDatePickers();
      this.collection = new takhfifan.TravelPlaneCollection;

      this.initFiltersAndDealCardsEvents();
      this.filters = {};
      this.sort = {
        type:"totalPrice",
        order: "asc"
      };
      this.pageSize = 20;

      takhfifan.eventHub.on('travel:flightReset', function(){
        takhfifan.travelSearchRoute.navigate("#travel_view/search",{trigger: true, replace: false});

        if(takhfifan.travelSearchTimeOut){
          clearTimeout(takhfifan.travelSearchTimeOut);
        }
        $('.travel-plane-results').addClass('travel-plane-results--no-result');
        Lockr.set("travelSearchTime","");
        Lockr.set("travelFlightModel","");
        Lockr.set("travelFlightSearchModel","");
      }, this);
    },

    generateSelectBoxes: function(){
      this.$('select.tkh-travel-plane-search__txt').SumoSelect({
        search: true,
        showTitle: true,
        noMatch: 'موردی یافت نشد.',
        searchText: 'جستجو کنید...',
        forceCustomRendering: false,
        nativeOnDevice: false,
        floatWidth: 0
      });
      this.$('select.tkh-travel-plane-search__number').SumoSelect();
    },

    formatDate: function(unix){
      var currentDate = new Date(unix);
      return (currentDate.getFullYear()+"-"+this.addLeadingZero(currentDate.getMonth() +1) +"-"+this.addLeadingZero(currentDate.getDate()));
    },

    addLeadingZero: function (n) {
      var s = "0"+n;
      return s.substr(s.length-2);
    },

    generateDatePickers: function(){
      var _this = this,
          dpOptions = {
            onSelect: function(unix){
              var selectedDate=this.model.state.selected,
                $placeHolder = $(this.model.inputElement),
                selectedDateText = _this.formatDate(unix);
              $placeHolder.html(selectedDate.year+"/"+selectedDate.month+"/"+selectedDate.date);
              $placeHolder.addClass('travel-search-types__form__dp--has-value');

              if($placeHolder.data("type")==="from"){
                _this.model.set({departDate:selectedDateText});
                _this.validateForm();

                _this.fromDP.touched = true;
                if (_this.toDP && _this.toDP.options && _this.toDP.options.minDate != unix) {
                  var cachedValue = _this.toDP.getState().selected.unixDate;
                  _this.toDP.options = {minDate: unix};
                  if (_this.toDP.touched) {
                    _this.toDP.setDate(cachedValue);
                  }
                }

              }else{
                _this.model.set({returnDate:selectedDateText});
                _this.validateForm();

                _this.toDP.touched = true;
                if(_this.fromDP && _this.fromDP.options && _this.fromDP.options.maxDate != unix){
                  var cachedValue = _this.fromDP.getState().selected.unixDate;
                  _this.fromDP.options = {maxDate: unix};
                  if (_this.fromDP.touched) {
                    _this.fromDP.setDate(cachedValue);
                  }
                }
              }
            },
            minDate: new Date(),
            maxDate: null,
            autoClose: true,
            toolbox:{
              calendarSwitch:{
                enabled: false
              }
            }
          };

      var $datePickers = $(".tkh-travel-date-picker");
      $datePickers.each(function(){
        $(this).removeClass('travel-search-types__form__dp--has-value');
        $(this).html($(this).data("ph"));
      });

      if(this.fromDP){
        this.fromDP.options = dpOptions;
      }
      if(this.toDP){
        this.toDP.options = dpOptions;
      }
      if(!this.toDP || !this.fromDP){
        $datePickers.each(function(){
          var dp = $(this).pDatepicker(dpOptions);
          if($(this).data("type")==="from"){
            _this.fromDP = dp;
          }else{
            _this.toDP = dp;
          }
        });
      }
    },

    changeDirection: function(e){
      var $target = $(e.target),
          is2Way = parseInt($target.data('dir'),10) === 2;

      if($target.hasClass('active')){
        return;
      }
      this.model.set({is2Way: is2Way, returnDate:null, departDate: null});
      this.$('.tkh-travel-plane-search__dir').toggleClass('active');
      if(is2Way){
        this.$('.tkh-travel-date-picker[data-type="to"]').show();

      }else{
        this.$('.tkh-travel-date-picker[data-type="to"]').hide();
      }
      this.generateDatePickers();
      this.validateForm();
    },

    setModelData: function(e){
      var $this = $(e.target),
          name = $this.prop('name'),
          attrs={};

      attrs[name] = $this.val();
      this.model.set(attrs);
      this.validateForm();
    },

    validateForm: function () {
      this.model.validate();
      if(this.model.isValid()){
        this.$('.travel-search__btn').removeAttr('disabled');
      }else{
        this.$('.travel-search__btn').attr('disabled','disabled');
      }
    },

    searchFormSubmit: function (e){
      e.preventDefault();
      takhfifan.eventHub.trigger('travel:disable');
      Lockr.set("travelFlightSearchModel", this.model);
      this.sendAjaxRequest();
    },

    sendAjaxRequest: function (tryCount) {
      var _this = this,
          tryCount = tryCount ||0;
      this.collection.fetch({
        dataType: 'json',
        data: {
          origin: this.model.get('origin'),
          destination: this.model.get('destination'),
          depart_date: this.model.get('departDate'),
          returnDate: this.model.get('returnDate'),
          capacity: this.model.passengersCount()
        },
        success: function (collection, response, options) {
          if(tryCount <10) {
            if (options.xhr.status == 204) {
              tryCount++;
              setTimeout(function() {
                _this.sendAjaxRequest.call(_this, tryCount);
              }, 3000);
            } else {
              _this.filters = {};
              _this.sort = {
                type:"totalPrice",
                order: "asc"
              };
              _this.renderSearchResults(collection);
            }
          }else{
            takhfifan.eventHub.trigger('travel:enable');
            takhfifan.eventHub.trigger('message:show', {
              type: 'error',
              msg: 'در حال حاضر پاسخی دریافت نمیشود. لطفا مجددا تلاش کنید'
            });
          }
        },
        error: function() {},
        complete: function () {}
      })
    },

    initFiltersAndDealCardsEvents: function () {
      var _this = this;

      $(document).on('change', '.tkh-travel-plane-filter', function (e) {
        var $target = $(e.target);
        if($target.is(":checked")){
          _this.filters[$target.data('type')].push($target.data('val'))
        }else{
          _this.filters[$target.data('type')] = _.without(_this.filters[$target.data('type')],$target.data('val'))
        }

        _this.currentPage = 0;
        _this.renderCards(false);
      });

      $(document).on('click', '.tkh-travel-plane-card__more', function (e) {
        var $target = $(e.target);
        $target.parents('.tkh-travel-plane-card').toggleClass('travel-plane-result--with-details');
      });

      $(document).on('click', '.tkh-travel-plane-sort', function (e) {
        var $target = $(e.target);
        $target.parents('.tkh-travel-plane-results__sorts').find('.tkh-travel-plane-sort').removeClass('active');
        $target.addClass('active');
        _this.currentPage = 0;
        _this.sort.type = $target.data('sortType');
        _this.sort.order = $target.data('sortOrder');
        _this.renderCards(false);
      });

      $(document).on('click', '.tkh-travel-plane-results__show-more', function (e) {
        _this.currentPage++;
        $(this).remove();
        _this.renderCards(true);
      });

      $(document).on('click', '.tkh-travel-plane-card__btn', function (e) {
        var $target = $(e.target),
            model = _this.collection.get($target.parents('.tkh-travel-plane-card').data('model'));
        takhfifan.eventHub.trigger('travel:addToCart', {depSearchId: 0, depId:0, retSearchId:0,retId: 0});
        takhfifan.eventHub.trigger('travel:disable');
        Lockr.set("travelFlightModel", model);
      });

    },

    renderCards: function(append){
      var _this = this;
      var models = _.filter(this.collection.models, function(model){
        var shouldShown = true;
        _.each(_this.filters,function (list,key) {
          if(list.length>0){
            if(_.indexOf(list, model.get('departure')[key]) === -1 || (model.get('returnData') && _.indexOf(list, model.get('returnData')[key])) === -1){
              shouldShown = false;
            }
          }
        });
        return shouldShown;
      });

      if(this.sort){
        models = _.sortBy(models, function(model){
          return _this.sort.order ==="asc" ? model.get(_this.sort.type): -model.get(_this.sort.type);
        });
      }

      if(!append){
        $('.tkh-travel-plane-results__container').html('');
      }

      var numberOfPages = Math.ceil(models.length / this.pageSize) - 1;
      models = _.rest(models, (this.currentPage) * this.pageSize);
      models = _.first(models, this.pageSize);

      $('.tkh-travel-plane-results__container').append(
        _this.cardTemplate({models:models, showMore: this.currentPage<numberOfPages})
      );
    },

    renderSearchResults: function (collection) {
      takhfifan.eventHub.trigger('travel:enable');
      var _this = this;
      $('html, body').animate({
        scrollTop: $('.travel-plane-results').offset().top - 150
      }, 500);
      Lockr.set("travelSearchTime", new Date());
      if(takhfifan.travelSearchTimeOut){
        clearTimeout(takhfifan.travelSearchTimeOut);
      }

      takhfifan.travelSearchTimeOut = setTimeout(function(){
        takhfifan.eventHub.trigger('message:show', {
          type: 'error',
          msg: 'مدت اعتبار جستجو تمام شد، لطفا مجددا جستجو کنید'
        });
        takhfifan.eventHub.trigger('travel:flightReset');
      }, 900000);

      if(!this.collection.models.length){
        takhfifan.eventHub.trigger('message:show', {
          type: 'error',
          msg: 'جستجوی شما نتیجه ای در بر نداشت!'
        });
      }else{
        $('.travel-plane-results').removeClass('travel-plane-results--no-result');
        $('.landingSection').css('display', 'none');
        takhfifan.eventHub.trigger('travel:renderResults', {type:'flights'});
      }
      this.currentPage = 0;
      this.renderCards(false);

      var _this = this;
      _.each(collection.filters, function(filter){
        _this.filters[filter.type] = [];
      });
      $('.tkh-travel-plane-results__filters').html(_this.filtersTemplate({filters:collection.filters}));
    }
  });


});

